import Select, {
    components,
    OptionProps,
    SingleValueProps,
} from "react-select";
import { useTranslation } from "react-i18next";
import USAFlagRound from "../assets/usa_flag_round.svg";
import ESPFlagRound from "../assets/esp_flag_round.svg";
import { isHabitnuApp } from "../utils/white-label";

interface OptionState {
    value: string;
    label: string;
    flagURL: string;
}

function Option(props: OptionProps<OptionState>) {
    const { data } = props;
    return (
        <components.Option {...props}>
            <div className="d-flex justify-content-center align-items-center">
                <img
                    src={data.flagURL}
                    alt={`Flag for ${data.label}`}
                    style={{ width: 36, height: 36 }}
                    className="pr-2 flag-icon"
                />
                {data.label}
            </div>
        </components.Option>
    );
}

function Value(props: SingleValueProps<OptionState>) {
    const { data } = props;
    return (
        <components.SingleValue {...props}>
            <div
                className="d-flex justify-content-center align-items-center"
                style={{
                    color: isHabitnuApp() ? "#00087a" : "inherit",
                }}
            >
                <img
                    src={data.flagURL}
                    alt={`Flag for ${data.label}`}
                    className="flag-single-icon"
                />
                <span className="font-weight-600">
                    &nbsp;&nbsp;{data.label}
                </span>
            </div>
        </components.SingleValue>
    );
}

interface Props {
    className?: string;
}

export function LanguageSwitch({ className }: Props) {
    const { i18n } = useTranslation();
    const OPTIONS: OptionState[] = [
        {
            value: "en",
            label: "EN",
            flagURL: USAFlagRound,
        },
        {
            value: "es",
            label: "ES",
            flagURL: ESPFlagRound,
        },
    ];

    return (
        <Select
            className={
                className || isHabitnuApp()
                    ? "text-center m-auto language-width habitnu-choose-language"
                    : "text-center m-auto language-width choose-language"
            }
            menuPosition="fixed"
            classNamePrefix="language-switch"
            isSearchable={false}
            isClearable={false}
            styles={{
                menuPortal: (base: Record<string, unknown>) => ({
                    ...base,
                    zIndex: 9999, // Ensures dropdown is above other components
                }),
                control: (base: Record<string, unknown>) => ({
                    ...base,
                    cursor: "pointer",
                }),
            }}
            value={
                i18n.language
                    ? OPTIONS.find(
                          ({ value }) => value === i18n.language.split("-")[0]
                      )
                    : OPTIONS[0]
            }
            options={OPTIONS}
            components={{ SingleValue: Value, Option }}
            onChange={(selected) => {
                const s = selected as OptionState;
                void i18n.changeLanguage(s.value);
            }}
        />
    );
}
